module.exports = __webpack_public_path__ + "static/media/433420474_906567698140996_6690642174062579889_n.c14db98a.jpg";